type SmartsuppFunctions = ((fn: 'chat:show') => void) &
  ((fn: 'chat:hide') => void)

interface SmartsuppApi {
  _smartsupp: { key: string }
  smartsupp: SmartsuppFunctions & {
    _: any[]
  }
}

declare global {
  interface Window extends SmartsuppApi {}
}

export const useSmartsupp = () => {
  const {
    public: { smartsuppKey },
  } = useRuntimeConfig()

  const { acceptedAnalytics } = useConsent()

  if (import.meta.client) {
    const _smartsupp = { key: smartsuppKey }
    window._smartsupp = _smartsupp

    window.smartsupp =
      window.smartsupp ||
      function (...params: any[]) {
        ;(window.smartsupp._ = window.smartsupp._ || []).push(params)
      }
  }

  return useScript(
    {
      src: 'https://www.smartsuppchat.com/loader.js?',
      crossorigin: false,
      async: true,
    },
    {
      trigger: acceptedAnalytics,
      use() {
        return { smartsupp: window.smartsupp }
      },
    }
  )
}
